module.exports = __webpack_public_path__ + "static/media/13.f8c78361.png";